import { Select, Space } from "antd";
import React, { useContext, useEffect, useRef, useState } from "react";
import trans from "../../../utils";
import { popupcontext } from "../../../context/Popupscontext";
import { useGetAllPOIsQuery } from "../../../Redux/service/POIS/POIs";
import { useGetPOIsUnderUserQuery } from "../../../Redux/service/Permissions/POIsPermissions";

export default function POIsMultiInput({
  label,
  styling,
  handleLink,
  handleUnLink,
  vehicleId,
  userId,
  type,
}) {
  const { isLinking } = useContext(popupcontext);
  const [mergedData, setMergedData] = useState([]);
  const [isOpen, setIsOpen] = useState(false);
  const [selectedPOIs, setSelectedPOI] = useState([]);
  const [groups, setGroups] = useState([]);

  // let { data: NotificationsVehicles, refetch: NotificationsVehiclesRefetch } =
  // 	useGetAllTechnicianFromUsersQuery();
  let { data: UsersPOIs, refetch: UsersPOIsRefetch } = useGetAllPOIsQuery(
    {
      page: 1,
      limit: 10000,
    },
    { refetchOnMountOrArgChange: true }
  );
  let { data: Users, refetch: UsersRefetch } = useGetPOIsUnderUserQuery(
    {
      userId,
    },
    { refetchOnMountOrArgChange: true }
  );
  const handleDropdownVisibleChange = (visible) => {
    if (visible) {
      setIsOpen(true);
    } else {
      setIsOpen(false);
    }
  };
  const isFirstMount = useRef(true);

  useEffect(() => {
    try {
      // Safely extract arrays
      const customers = Array.isArray(UsersPOIs?.data) ? UsersPOIs.data : [];
      const users = Array.isArray(Users?.data?.connections)
        ? Users?.data?.connections
        : [];

      // Merge safely

      const merged = [...customers, ...users?.map((i) => i?.poi)];
      // Ensure items have IDs before filtering
      const unique = merged.filter(
        (item, index, self) =>
          item &&
          item.id &&
          item.status === true &&
          index === self.findIndex((t) => t && t.id === item.id)
      );

      setMergedData(unique);
    } catch (err) {
      console.error("Error merging UserPOIs and Users:", err, {
        UsersPOIs,
        Users,
      });
    }
  }, [UsersPOIs, Users]);

  console.log("MergedDataPOIS", mergedData);

  useEffect(() => {
    if (isFirstMount.current || UsersPOIsRefetch || UsersRefetch) {
      if (mergedData?.length > 0) {
        setGroups(
          mergedData?.map((i) => ({
            value: i.id,
            label: i.name,
          }))
        );
      }
    }
    isFirstMount.current = false;
  }, [mergedData, UsersPOIsRefetch, UsersPOIs, UsersRefetch]);

  useEffect(() => {
    if (type === "users") {
      if (Users?.data?.connections?.length > 0) {
        setSelectedPOI(Users?.data?.connections?.map((i) => i.connectedPoiId));
      }
    }
  }, [Users, type]);
  console.log("selectedPOIs", selectedPOIs);
  console.log("Users", Users);
  useEffect(() => {
    if (isLinking) {
      if (type === "users") {
        UsersRefetch();
      }
    }
  }, [isLinking, vehicleId, type, UsersRefetch]);
  return (
    <div className={styling}>
      {label && <div className="mult-input-label">{trans(label)}</div>}
      <Space
        style={{
          width: "100%",
          borderColor: "red",
        }}
        direction="vertical"
      >
        <Select
          mode="multiple"
          style={{
            width: "100%",
            marginTop: "8px",
            borderColor: "red",
          }}
          maxTagCount={"responsive"}
          placeholder={trans("Please select")}
          onSelect={(value) => {
            setSelectedPOI((prev) => [...prev, value]);
            handleLink(value, "connectedPoiId", "POIs");
          }}
          onDeselect={(value) => {
            setSelectedPOI((prev) => prev.filter((v) => v !== value));
            handleUnLink(value, "connectedPoiId", "POIs");
          }}
          value={(selectedPOIs?.length > 0 && selectedPOIs) || null}
          options={groups}
          open={isOpen}
          onDropdownVisibleChange={handleDropdownVisibleChange}
          filterOption={(input, option) =>
            option.label.toLowerCase().includes(input.toLowerCase())
          }
        />
      </Space>
    </div>
  );
}
